export default __webpack_public_path__ + "static/media/home_favorit.6eb0c179.svg";